import React, { useCallback } from "react";
import GenericBox from "components/ui/Box";
import { User, UserCheck } from "lucide-react";
import { usePanel } from "hooks/usePanel";
import { Sizes } from "components/ui/Loader";
import { UpsertNaturalPerson } from "features/new-actor/components/UpsertNaturalPerson";
import { NsKey } from "enums/NsKey";
import { useTranslation } from "react-i18next";
import { NaturalPersonDto } from "api/contract";
import { useUnemploymentRiskData } from "features/subscription-process/contexts/selectors/selectors";
import { SubscriptionProcessContext, useSubscriptionProcess } from "features/subscription-process/contexts/SubscriptionProcessContext";
import { withPersonName } from "shared/utils/panelTitle";

// Helper function moved from original component
function calculateAge(dateOfBirth: Date): number {
  const today = new Date();
  let age = today.getFullYear() - dateOfBirth.getFullYear();
  const hasBirthdayPassed =
    today.getMonth() > dateOfBirth.getMonth() ||
    (today.getMonth() === dateOfBirth.getMonth() && today.getDate() >= dateOfBirth.getDate());
  if (!hasBirthdayPassed) {
    age--;
  }
  return age;
}

// Helper function to capitalize first letter
function capitalizeFirstLetter(str: string): string {
  if (!str) return str;
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

export const InsuredUnemploymentCard: React.FC = () => {
  const { openPanel } = usePanel()
  const { t } = useTranslation(NsKey.Common)
  const riskData = useUnemploymentRiskData()
  const person = riskData?.person
  const contextValue = useSubscriptionProcess()

  const naturalPerson = person as NaturalPersonDto

  const onSelectSubscriber = useCallback(() => {
    if (person) {
      openPanel({
        title: withPersonName("Details de l'assuré", `${naturalPerson.firstName} ${naturalPerson.lastName}`),
        size: Sizes["2xl"],
      },
        <SubscriptionProcessContext.Provider value={contextValue}>
          <UpsertNaturalPerson />
        </SubscriptionProcessContext.Provider>
      )
    }
  }, [person, naturalPerson, openPanel, contextValue])

  return (
    <GenericBox
      onSelect={onSelectSubscriber}
      icon={User}
      title={t("COMMON.LABELS.INSURED")}
    >
      <div className="text-primary flex gap-1 text-sm">
        <p>{`${naturalPerson?.lastName.toLocaleUpperCase()}`}</p>
        <p>{`${capitalizeFirstLetter(naturalPerson?.firstName || '')}`}</p>
        <p>
          ({naturalPerson?.birthDate ? `${calculateAge(new Date(naturalPerson?.birthDate))} ans` : ''})
        </p>
      </div>
    </GenericBox>
  );
}
